module.exports = __webpack_public_path__ + "img/kids-courses.d2aedda8.png";